

































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetTem } from "@/request/common";
import QuestionImg from "@/components/question/question-img.vue";
import QuestionSelect from "@/components/question/question-select.vue";
import QuestionCard from "@/components/question/question-card.vue";
@Component({
  components: {
    QuestionImg,
    QuestionSelect,
    QuestionCard,
  },
})
export default class Name extends Vue {
  private id: any = "";
  private data: any = {};
  private questionIndex: any = null;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private changeCurIdx(index: any) {
    this.questionIndex = index;
  }
  private goBefore() {
    if (this.questionIndex == 0) {
      this.$message.warning("已经是第一题了");
      return;
    }
    this.questionIndex--;
  }
  private goNext() {
    if (this.questionIndex == this.data.questions.length - 1) {
      this.$message.warning("已经是最后一题了");
      return;
    }
    this.questionIndex++;
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        question_template_id: this.id,
      },
    };
    GetTem(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.ifShowYulan = true;
        this.data = [res];
        this.questionIndex = 0;
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getData();
    }
  }
}
